import React from "react";
import "../../styles/espCardView.scss";
import ReactDatePicker from "react-datepicker";
import { Button } from "../../common/Button/Button";
import { useEffect } from "react";
import { useState } from "react";
import Spinner from "../../common/Spinner/Spinner";
import api from "../../utils/api";
import Chart from "react-google-charts";
import MultiSelectAll from "../../common/Multiselect/MultiSelectAll";
//import ESPDashboardGrid from "../../components/EServicePartnerServiceRequests/ESPDashboardGrid";
//import EngagedDashboardGrid from "../../components/EServicePartnerServiceRequests/EngagedDashboardGrid";
import FirstTimeEngagedData from "../../components/EServicePartnerServiceRequests/FirstTimeEngagedData";
import EngagedUsersData from "../../components/EServicePartnerServiceRequests/EngagedUsersData";
import { SELECTED_SIDE_BAR_ITEM_KEY } from "../../common/SidebarContent/SidebarContent";
import { toast } from "react-toastify";
import { getESPUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import ic_filter from "./../../assets/ic_filter.svg";
import SPLedDashboardFilterModal from "../../components/EServicePartnerServiceRequests/SPLedDashboardFilterModal";
import moment from "moment";

//for admin 
import { getUser } from "../../utils/localStorage";
import { forEach } from "lodash";

export default function EngagedUsersReportContainer(props)
{

    var PastDate = new Date();
    PastDate.setMonth(PastDate.getMonth() - 1);


    const [FirstTimeResponse,setFirstTimeResponse]=useState(
        {
            engaged_users:0,
            first_time_users:0
        }
    );

    // const [fromDate, setfromDate] = useState(PastDate);
    // const [toDate, settoDate] = useState(new Date());
    const [fromDate, setfromDate] = useState( );
    const [toDate, settoDate] = useState();
    const[activePage,setActivePage]=useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [TableData,setTableData] =useState([]);
    const [TableDataEngaged,setTableDataEngaged] =useState([]);
    const [ChartData,setChartData] =useState([]);
    const [ChartData1,setChartData1]=useState([]);
    
    const arrChartData = [];
    const arrCharData1=[];
    const Data = [];


    const handleSearchClick = async () => {
        getTableData();
        adjustedToDate();
        

       setIsLoading(true);	
        // getTableData();
        //setServiceData(strData);
       
        //onExternalServicePartnerChange();
	};


    useEffect(() => {
        getTableData(); 
        //setIsLoading(true); 
	},[]);
    



    const ondatechange = (key, date) => {
		if (key === "fromDate") {
			setfromDate(date);
		} else if (key === "toDate") {
			settoDate(date);
		}
	};
   

    

    const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};





    const getTableData=()=>{
        let filterParameters = {};

        console.log(fromDate);
        console.log(toDate);

        if(fromDate)
        {
            filterParameters.fromDate=fromDate;
        }

        if(toDate)
        {
            filterParameters.toDate=adjustedToDate(toDate);
        }
        
        //let stesc=filterParameters;
        setIsLoading(true);	
        console.log(filterParameters);
        
        // const { tempServices } = api.getFirstTimeResponseData(filterParameters).then(({ data }) => {
    const { tempServices } = api.getengagedusercount(filterParameters).then(({ data }) => {
        //setIsLoading(false);
        if(data)
        {
            //setFirstTimeResponseData(data);
             setFirstTimeResponse(data[0]);
            
        }
        else
        {
            toast("", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
    }).catch((error) =>
    {
        //setIsLoading(false);
        if(error.response.data.detail)
        {
            toast(String(error.response.data.detail), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
        else if(error.response.data.message)
        {
            toast(String(error.response.data.message), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
        else
        {
            toast("Internal server error", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
        
    });

     


        //First time users data api
        const { tempServices1 } = api.getFirstTimeusersDashboradData(filterParameters).then(({ data }) => 
        {
        setIsLoading(false);
        if(data)
        {
            setTableData(data);
            let firsttimeusers;
            firsttimeusers= data.sort((a,b)=>{
               return parseInt(b.resourse_count)  - parseInt(a.resourse_count);
            })

            arrChartData.push(["Task", "number"],);
            
            if(firsttimeusers.length>0 && firsttimeusers.length>20)
            {
            for(let i=0;i<20;i++)
            {
                arrChartData.push([firsttimeusers[i].resourse_name,firsttimeusers[i].resourse_count]); 
                
            }
            setChartData(arrChartData);
            }
            else{
                for(let i=0;i<firsttimeusers.length;i++)
                {
                    arrChartData.push([firsttimeusers[i].resourse_name,firsttimeusers[i].resourse_count]); 
                    
                }
                setChartData(arrChartData);
            }
        }
        else
        {
            toast("", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }

       }).catch((error) =>
       {
        setIsLoading(false);
        if(error.response.data.detail)
        {
            toast(String(error.response.data.detail), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
        else if(error.response.data.message)
        {
            toast(String(error.response.data.message), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
        else
        {
            toast("Internal server error", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        } 
    });

    //end


    //Engaged Users Data api
    const { tempServices2 } = api.getEngagedusersDashboradData(filterParameters).then(({ data }) => {
            
        setIsLoading(false);
        if(data)
        {
            setTableDataEngaged(data);
            let engagedusers;
            engagedusers= data.sort((a,b)=>{
               return parseInt(b.resourse_count)  - parseInt(a.resourse_count);
            })
            arrCharData1.push(["Task", "number"]);


            if(engagedusers.length>0 && engagedusers.length>20)
            {
            for(let i=0;i<20;i++)
            {
                arrCharData1.push([engagedusers[i].resourse_name,engagedusers[i].resourse_count]); 
                
            }
            setChartData1(arrCharData1);
            }
            else{
                for(let i=0;i<engagedusers.length;i++)
                {
                    arrCharData1.push([engagedusers[i].resourse_name,engagedusers[i].resourse_count]); 
                    
                }
                setChartData1(arrCharData1);
            }

        }
        else
        {
            toast("", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
    }).catch((error) =>
    {
        setIsLoading(false);
        if(error.response.data.detail)
        {
            toast(String(error.response.data.detail), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
        else if(error.response.data.message)
        {
            toast(String(error.response.data.message), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
        else
        {
            toast("Internal server error", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
        
    });

        
    }

        return(
            <>
            {
                activePage===""?
                (
                    <div className={`${isLoading && "set-opacity"}`}>
                        {isLoading && <Spinner className="center-screen" />}
                        <div className="row"style={{marginTop:"10px"}}>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="row">
                                        <div className="col-2 spled-container conv-zindex">
                                        <div className="width-100">                                       
                                                <ReactDatePicker 
                                                   dateFormat="dd/MM/yyyy"
                                                   selected={fromDate}  
                                                   //onChange={(date) =>setfromDate(date)}
                                                   onChange={(date) =>ondatechange("fromDate",date)}
                                                   //minDate={new Date()}
                                                   placeholderText="From Date"   
                                                    
                                                />
                                            </div>
                                        </div>
                                        <div className="col-2 spled-container conv-zindex">
                                        <div className="width-100">
                                            <ReactDatePicker
                                           dateFormat="dd/MM/yyyy"
                                           selected={toDate}
                                           //onChange={(date) =>settoDate(date)}
                                           onChange={(date) =>ondatechange("toDate",date)}
                                           placeholderText="To Date"
                                            />
                                        </div>
                                        </div>
                                        <Button className="esp-inline-button" onClick={handleSearchClick}>Search</Button>
    
     
                                            <div className="col-3">
                                                <div className="esp-dashboard-card conv-text-center">
                                                    <label className="esp-box-header-title">First Time Users</label> 
                                                    <h5 className="esp-count-text">{FirstTimeResponse.first_time_users||0}</h5>
                                                    <div style={{clear:"both"}}></div>
                                                     
                                                </div>
                                            </div>
                                            <div className="col-3">
                                                <div className="esp-dashboard-card conv-text-center">
                                                    <label className="esp-box-header-title">Engaged Users</label> 
                                                    {/* <h5 className="esp-count-text">{FirstTimeResponse.engaged_users||0}</h5> */}
                                                    <h5 className="esp-count-text">{FirstTimeResponse.engaged_users&&FirstTimeResponse.engaged_users||0}</h5>
                                                    <div style={{clear:"both"}}></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 conv-mt15">
                                        <div className="row">
                                            <div className="col-6">
                                            <div className="esp-dashboard-card conv-text-center" style={{height:"344px"}}>
                                            <label className="esp-box-header-title">Resource Availed by First Time Users</label> 
                                            <div className="google-chart">
                                                <Chart
                                                    width={'100%'}  
                                                    height={'260px'}
                                                    chartType="PieChart"                                    
                                                    data={ChartData}
                                                    options={{
                                                        backgroundColor:"#FAFAFA",
                                                        title: '',
                                                        // Just add this option
                                                        is3D: true,
                                                        legend: { position: 'left' },
                                                        chartArea: {
                                                            left: 0,
                                                            top: 10,
                                                            right: 0,
                                                            bottom:0,
                                                            width: "100%",
                                                            height: "100%"
                                                        },
                                                    }}
                                                     
                                                />
                                                    {/* <Chart
                                                    chartType="PieChart"
                                                    data={ChartData}
                                                    //data={data}
                                                    //options={options}
                                                    width={"100%"}
                                                    height={"300px"}
                                                    /> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                            <div className="esp-dashboard-card conv-text-center" style={{height:"344px"}}>
                                            <label className="esp-box-header-title">Resource Availed by Engaged Users</label> 
                                            <div className="google-chart">
                                                <Chart
                                                    width={'100%'}  
                                                    height={'260px'}
                                                    chartType="PieChart"                                    
                                                    data={ChartData1}
                                                    options={{
                                                        backgroundColor:"#FAFAFA",
                                                        title: '',
                                                        // Just add this option
                                                        is3D: true,
                                                        legend: { position: 'left' },
                                                        chartArea: {
                                                            left: 0,
                                                            top: 10,
                                                            right: 0,
                                                            bottom:0,
                                                            width: "100%",
                                                            height: "100%"
                                                        },
                                                    }}
                                                    
                                                />
                                                {/* <Chart
                                                    chartType="PieChart"
                                                    data={ChartData1}
                                                    //options={option}
                                                    width={"100%"}
                                                    height={"300px"}
                                                    /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                    
                                </div>
                            </div>
                             
                            
                             
                        </div>
                        <div className="row conv-mt30 conv-mb30">
                             
                            <div className="col-6 service-partner spled-container engagedusers-report">
                                <FirstTimeEngagedData
                                data={TableData}
                                //ServiceData={ServiceData}
                                fromNewDesign={true}
                                />
                            </div>
                            <div className="col-6 service-partner spled-container engagedusers-report">
                                <EngagedUsersData
                                data={TableDataEngaged}
                                //ServiceData={ServiceData}
                                fromNewDesign={true}
                                />
                            </div>
                        </div>
                    </div>
                ):
                activePage==="No_Access"?
                (
                    <div className={`row row-container`}>
                            <div className="col-12 row-margin-10px" style={{textAlign:"center"}}>                                
                            <label>
                                <b>You are not allowed to access this page, Please contact admin for more details.</b>
                            </label>         
                        </div>
                    </div>
                )
                :
                (
                    ""
                )
            }
                
            </>
        );
}